/**
 * PDP Payment modal — delegates clicks on any [data-pdp-modal-open] trigger and
 * opens the matching <dialog> inside the current product section. Works with
 * multiple sections on the same page because the trigger's aria-controls points
 * at the scoped dialog id.
 */
(function () {
  'use strict';

  function findDialogForTrigger(trigger) {
    var id = trigger.getAttribute('aria-controls');
    if (!id) return null;
    return document.getElementById(id);
  }

  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
      } catch (e) {
        dialog.setAttribute('open', '');
      }
    } else {
      dialog.setAttribute('open', '');
      dialog.classList.add('is-open');
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      try {
        dialog.close();
      } catch (e) {
        dialog.removeAttribute('open');
      }
    } else {
      dialog.removeAttribute('open');
      dialog.classList.remove('is-open');
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pdp-modal-open]');
    if (trigger) {
      event.preventDefault();
      var dialog = findDialogForTrigger(trigger);
      openDialog(dialog);
      return;
    }

    var closer = event.target.closest('[data-pdp-modal-close]');
    if (closer) {
      var parent = closer.closest('dialog.pdp-payment-modal');
      closeDialog(parent);
      return;
    }

    // Click on backdrop (outside inner) closes the dialog.
    if (event.target && event.target.matches && event.target.matches('dialog.pdp-payment-modal')) {
      closeDialog(event.target);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('dialog.pdp-payment-modal[open]');
    if (open) closeDialog(open);
  });
})();
